import { checkPermissions } from '@artprov/design-system'
import { useMemo } from 'react';
import { ROLES } from '../constants.js';

/**
 * Hook para determinar qué secciones de matching puede ver el usuario
 * según sus roles de Keycloak.
 */
export function useMatchingRoles() {

    return useMemo(() => {
        const canViewBancario = checkPermissions(
            [ROLES.CONTABLE, ROLES.VIEW_ALL],
            { requireAll: false }
        );

        const canViewJudicial = checkPermissions(
            [ROLES.LEGALES, ROLES.VIEW_ALL],
            { requireAll: false }
        );

        return {
            canViewBancario,
            canViewJudicial,
            canViewBoth: canViewBancario && canViewJudicial,
            hasAnyMatchingAccess: canViewBancario || canViewJudicial,
        };
    }, [checkPermissions]);
}
